<template>
  <div class="toasts" v-if="toastlist.length > 0">
    <span class="toast-item" :class="{ 'fade-out': item.fadeOut }" :style="{ 'top': '-' + (0.3 * index) + 'rem'}" v-for="(item, index) in toastlist">{{item.text}}</span>
  </div>
</template>

<script>
import { bus } from '../common'
export default {
  props: {
  },
  data() {
    return {
      toastlist : [],
    };
  },
  methods: {
  },
  mounted() {
    bus.$on('toast', (options) => {
      if(typeof options === 'string'){
        options = {text : options}
      }
      let toastlist = this.toastlist;
      let defaultOptions = {
        text : '提示',
        time : 3000,
        fadeOut : false,
      }
      toastlist.push(Object.assign(defaultOptions, options));
      setTimeout(() => {
        toastlist.splice(toastlist.findIndex(x => x == defaultOptions), 1)
        defaultOptions.callback && defaultOptions.callback()
      }, defaultOptions.time);
      setTimeout(() => {
        defaultOptions.fadeOut = true
      }, defaultOptions.time > 1000 ? defaultOptions.time - 1000 : 0);
    })
  },
};
</script>

<style lang="scss" scoped>
.toasts{
  position: fixed;
  bottom: 1.2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  height: 0px;
  overflow: visible;
  .toast-item{
    background-color: rgba(50,50,50, 0.8);
    border-radius: .05rem;
    padding: .05rem .1rem;
    color: #eeeeee;
    position: relative;
    line-height: .2rem;
    min-height: .3rem;
    max-height: .3rem;
    transition: opacity 1s linear;
    opacity:100;
    filter:alpha(opacity=100);
    &.fade-out{
      opacity:0;
      filter:alpha(opacity=0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toasts.vue